/**
 * All FichaOncologica dot-notation field paths with human-readable labels.
 * Used by the InterviewBuilder's QuestionEditor for the maps_to dropdown.
 * Generated from app/schemas/oncology.py
 */
const fichaFields = [
    // --- Demográficos ---
    { path: "demograficos.edad", label: "Edad", section: "Demográficos" },
    { path: "demograficos.fecha_nacimiento", label: "Fecha de nacimiento", section: "Demográficos" },
    { path: "demograficos.telefono_contacto", label: "Teléfono de contacto", section: "Demográficos" },
    { path: "demograficos.sexo", label: "Sexo (F/M)", section: "Demográficos" },
    { path: "demograficos.unidad_referencia", label: "Unidad de referencia", section: "Demográficos" },
    { path: "demograficos.fecha_referencia", label: "Fecha de referencia", section: "Demográficos" },
    { path: "demograficos.fecha_ingreso_hospital", label: "Fecha ingreso hospital", section: "Demográficos" },
    { path: "demograficos.motivo_consulta", label: "Motivo de consulta", section: "Demográficos" },
    { path: "demograficos.sintoma_inicial", label: "Síntoma inicial", section: "Demográficos" },
    { path: "demograficos.primer_contacto", label: "Primer contacto", section: "Demográficos" },
    { path: "demograficos.peso", label: "Peso (kg)", section: "Demográficos" },
    { path: "demograficos.talla", label: "Talla (cm)", section: "Demográficos" },
    { path: "demograficos.tamizaje", label: "Tamizaje", section: "Demográficos" },
    { path: "demograficos.mastografia_diagnostica", label: "Mastografía diagnóstica", section: "Demográficos" },
    { path: "demograficos.ante_familiares_cancer_mama", label: "Antecedentes familiares cáncer mama", section: "Demográficos" },
    { path: "demograficos.comorbilidades", label: "Comorbilidades", section: "Demográficos" },
    { path: "demograficos.observaciones", label: "Observaciones", section: "Demográficos" },
    { path: "demograficos.estatus", label: "Estatus del paciente", section: "Demográficos" },
    { path: "demograficos.factores_riesgo", label: "Factores de riesgo", section: "Demográficos" },
    { path: "demograficos.tratamiento_fuera_issste", label: "Tratamiento fuera ISSSTE", section: "Demográficos" },
    { path: "demograficos.metodo_diagnostico_inicial", label: "Método diagnóstico inicial", section: "Demográficos" },
    { path: "demograficos.estado_vital", label: "Estado vital", section: "Demográficos" },

    // --- Riesgos ---
    { path: "riesgos.riesgo_identificado", label: "Riesgo identificado", section: "Riesgos" },
    { path: "riesgos.clinicos", label: "Factores clínicos", section: "Riesgos" },
    { path: "riesgos.extension_momento", label: "Extensión al momento", section: "Riesgos" },
    { path: "riesgos.resecabilidad", label: "Resecabilidad", section: "Riesgos" },
    { path: "riesgos.recurrencia", label: "Recurrencia", section: "Riesgos" },
    { path: "riesgos.antecedentes_heredofamiliares", label: "Antecedentes heredofamiliares", section: "Riesgos" },
    { path: "riesgos.antecedentes_personales_patologicos", label: "Antecedentes personales patológicos", section: "Riesgos" },
    { path: "riesgos.medicamentos_hormonales", label: "Medicamentos hormonales", section: "Riesgos" },
    { path: "riesgos.edad_menarquia", label: "Edad menárquia", section: "Riesgos" },
    { path: "riesgos.edad_menopausia", label: "Edad menopausia", section: "Riesgos" },
    { path: "riesgos.numero_hijos", label: "Número de hijos", section: "Riesgos" },
    { path: "riesgos.lactancia", label: "Lactancia", section: "Riesgos" },

    // --- Hallazgos ---
    { path: "hallazgos.birads", label: "BI-RADS", section: "Hallazgos" },
    { path: "hallazgos.densidad_mamaria", label: "Densidad mamaria (ACR)", section: "Hallazgos" },
    { path: "hallazgos.tipo_estudio", label: "Tipo de estudio", section: "Hallazgos" },
    { path: "hallazgos.descripcion_hallazgo", label: "Descripción del hallazgo", section: "Hallazgos" },
    { path: "hallazgos.nodulo_forma", label: "Nódulo: forma", section: "Hallazgos" },
    { path: "hallazgos.nodulo_margen", label: "Nódulo: margen", section: "Hallazgos" },
    { path: "hallazgos.nodulo_densidad", label: "Nódulo: densidad", section: "Hallazgos" },

    // --- Patología ---
    { path: "patologia.diagnostico", label: "Diagnóstico patológico", section: "Patología" },
    { path: "patologia.tipificacion", label: "Tipificación", section: "Patología" },
    { path: "patologia.estadificacion", label: "Estadificación", section: "Patología" },
    { path: "patologia.biomarcadores", label: "Biomarcadores (RE, RP, HER2, Ki67)", section: "Patología" },

    // --- Etapa Clínica ---
    { path: "etapa_clinica.etapa", label: "Etapa clínica", section: "Etapa Clínica" },
    { path: "etapa_clinica.cT", label: "cT (tumor)", section: "Etapa Clínica" },
    { path: "etapa_clinica.cN", label: "cN (ganglios)", section: "Etapa Clínica" },
    { path: "etapa_clinica.cM", label: "cM (metástasis)", section: "Etapa Clínica" },
    { path: "etapa_clinica.tamano", label: "Tamaño tumoral", section: "Etapa Clínica" },

    // --- Cirugía ---
    { path: "cirugia.tipo_procedimiento", label: "Tipo de procedimiento quirúrgico", section: "Cirugía" },
    { path: "cirugia.objetivo", label: "Objetivo de la cirugía", section: "Cirugía" },
    { path: "cirugia.cirujano", label: "Cirujano", section: "Cirugía" },

    // --- Atención Integral ---
    { path: "atencion_integral.estado_funcional", label: "Estado funcional", section: "Atención Integral" },
    { path: "atencion_integral.paciente_red_apoyo", label: "Red de apoyo", section: "Atención Integral" },

    // --- Resumen Clínico ---
    { path: "resumen_clinico.sle", label: "Supervivencia libre de enfermedad", section: "Resumen Clínico" },
    { path: "resumen_clinico.sg", label: "Supervivencia global", section: "Resumen Clínico" },
    { path: "resumen_clinico.etapa_patologica", label: "Etapa patológica", section: "Resumen Clínico" },
];

// Group by section for the dropdown
export const fichaFieldsBySection = fichaFields.reduce((acc, field) => {
    if (!acc[field.section]) acc[field.section] = [];
    acc[field.section].push(field);
    return acc;
}, {});

export default fichaFields;
